define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.constants = void 0;
    exports.constants = {
        produktspartenLabels: {
            BAUFINANZIERUNG: {
                beratungsleistung: "Finanzierungsvorschläge für Ihre Baufinanzierung",
                teaser: "Baufinanzierung: Jetzt Finanzierungsvorschläge anfordern",
                formiName: "baufidrk01",
            },
            RATENKREDIT: {
                beratungsleistung: "ein Ratenkreditangebot",
                teaser: "Ratenkredit: Jetzt Kreditangebot anfordern",
                formiName: "ratenkreditdrk01",
            },
            VERSICHERUNG: {
                beratungsleistung: "Beratung zu Ihren Versicherungen",
                teaser: "Versicherung: Jetzt Beratung anfordern",
            },
            GELDANLAGE: {
                beratungsleistung: "eine Anlageberatung",
                teaser: "Geldanlage: Jetzt Anlageberatung anfordern",
            }
        },
    };
});
